module.exports = __webpack_public_path__ + "img/Website_Screenshot_3.31f3c02f.jpg";